import { Button as WPButton } from "@wordpress/components";
import { useDispatch } from "react-redux";
import { useProductContext } from "vino/context";
import { addCartLineItem } from "store/vino/cartSlice";

const AddToCartButton = () => {
	const dispatch = useDispatch();
	const { product } = useProductContext();
	const { variant } = product;

	const handleAddToCart = () => {
		try {
			const lineItem = {
				productId: product.id,
				variantId: variant.id,
				quantity: 1,
				product: {
					id: product.id,
					name: product.name,
					imageSrc: product.imageSrc,
				},
				variant: {
					name: variant.name,
					price: variant.price,
				},
			};
			dispatch(addCartLineItem(lineItem));
		} catch (error) {
			console.error(error);
		}
	};

	return (
		<button onClick={handleAddToCart} className="btn btn-primary action-btn">
			<div className="add-prod flex w-full justify-between">
				<i className="fa-solid fa-cart-shopping mx-5" />
				<span className="mr-3">Add To Cart</span>
			</div>
		</button>
	);
};

export default AddToCartButton;
